import React from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Container, Typography } from '@mui/material';
import useResponsive from '../hooks/useResponsive';
import Logo from '../components/logo';
import { SignUpForm } from '../sections/auth/signup';
import SEO from '../components/SEO';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 580,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows?.card || '0px 4px 20px rgba(0, 0, 0, 0.1)',
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',

  // Apply these only for sm and up
  [theme.breakpoints.up('sm')]: {
    minHeight: '100vh',
    padding: theme.spacing(12, 0),
  },

  // For mobile (xs) → no minHeight or big padding
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4, 0), // smaller padding
  },
}));


// const ToggleSwitch = styled('div')(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   gap: theme.spacing(2),
// }));

// const SwitchButton = styled(Button)(({ theme }) => ({
//   padding: theme.spacing(1),
//   borderRadius: '20px', // Round button shape
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.primary.contrastText,
//   '&.active': {
//     backgroundColor: theme.palette.secondary.main,
//   },
// }));

export default function SignUpPage() {
  const mdUp = useResponsive('up', 'lg');
  // const [showCompanyForm, setShowCompanyForm] = useState(false);

  // const toggleForm = () => {
  //   setShowCompanyForm(!showCompanyForm);
  // };

  return (
    <>
      <SEO
        title="WatchNod Sign Up | Start Server & API Monitoring"
        description="Create your WatchNod account to start monitoring servers, APIs, and domains with real-time alerts, uptime tracking, and easy setup."
        url="/signup"
        type="website"
        noindex
      />
      <StyledRoot>
        <Logo
          alt="WatchNod"
          title="WatchNod Logo"
          loading="eager"
          sx={{
            position: {
              xs: 'static', // scrolls with content on mobile
              sm: 'fixed',  // fixed only for larger screens
            },
            top: { xs: 'auto', sm: 0, md: 0 },
            left: {
              xs: 'auto', // no need to manually center when static
              sm: 20,
              md: 20,
            },
            transform: {
              xs: 'none',
              sm: 'none',
            },
            display: 'block',
            margin: { xs: '16px auto', sm: 0 }, // center with margin on mobile
          }}
        />

        {mdUp && (
          <StyledSection>
            <Typography
              sx={{
                px: 5,
                mt: 15,
                mb: 5,
                textAlign: 'center',
                color: '#333333',
                fontSize: '2.3rem',
                fontWeight: 'bold',
              }}
            >
              Explore <br />
              <span style={{ fontSize: '2.3rem', fontWeight: 'bold' }}>WatchNod</span>
            </Typography>
            <img
              src="/assets/illustrations/Mobile-login-Cristina.jpg"
              alt="Signup"
              title="Signup"
              width="100%"
              height="60%"
              loading="lazy"
            />
          </StyledSection>
        )}

        <Container maxWidth="sm">
          <StyledContent>
            <h1>
              <Typography variant='h3' gutterBottom>
                Sign Up to the WatchNod
              </Typography>
            </h1>
            <Typography variant="body1" sx={{ mb: 2 }}>
              You have an account? <Link to="/login">Get started (Login)</Link>
            </Typography>

            <SignUpForm />

            {/* <ToggleSwitch sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, mb: 1 }}>
              <SwitchButton
                onClick={() => !showCompanyForm && toggleForm()}
                className={!showCompanyForm ? 'active' : ''}
              >
                Personal
              </SwitchButton>
              <SwitchButton onClick={() => showCompanyForm && toggleForm()} className={showCompanyForm ? 'active' : ''}>
                Company
              </SwitchButton>
            </ToggleSwitch>

             <Divider sx={{ mb: 1 }} /> 
            {showCompanyForm ? <SignUpForm /> : <CompanySignUpForm />
            */}
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
